export default __webpack_public_path__ + "static/media/beach.fd8b6961.svg";